import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { NAV_LINKS } from "../mock";
import { useContent } from "../context/ContentContext";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { c } = useContent();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-[0_1px_0_rgba(15,36,56,0.08),0_8px_24px_-16px_rgba(15,36,56,0.25)]" : "border-b border-slate-100"
      }`}
    >
      <div className="mx-auto flex h-[68px] max-w-[1200px] items-center justify-between px-5 lg:px-8">
        <Link to="/" className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-[var(--navy)] text-white font-extrabold text-lg">O</div>
          <div className="leading-none">
            <div className="font-display text-[17px] font-extrabold text-[var(--ink)]">{c.brand.line1}</div>
            <div className="mt-[3px] text-[10px] font-semibold tracking-[0.22em] text-slate-400">{c.brand.line2}</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((l, i) => (
            <Link
              key={i}
              to={l.to}
              className={`rounded-lg px-3 py-2 text-[14px] font-medium transition-colors ${
                isActive(l.to) ? "bg-slate-100 text-[var(--ink)]" : "text-slate-500 hover:text-[var(--ink)]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => navigate("/providers")}
          className="flex items-center gap-2 rounded-xl bg-[var(--navy)] px-3.5 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-[var(--navy-800)] sm:px-4 sm:text-[14px]"
        >
          <Search size={16} strokeWidth={2.5} />
          <span className="hidden sm:inline">{c.header.cta}</span>
        </button>
      </div>

      {/* Mobile nav — all menu items visible (wraps), same links as desktop */}
      <nav className="flex flex-wrap items-center gap-1.5 border-t border-slate-100 px-4 py-2.5 lg:hidden">
        {NAV_LINKS.map((l, i) => (
          <Link
            key={i}
            to={l.to}
            className={`rounded-lg px-2.5 py-1.5 text-[13px] font-medium transition-colors ${
              isActive(l.to) ? "bg-slate-100 text-[var(--ink)]" : "text-slate-500 hover:text-[var(--ink)]"
            }`}
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
